import {
  FaSearch,
  FaBell,
  FaEnvelope,
  FaChevronDown,
  FaUserCircle,
} from "react-icons/fa";
import languageIcon from "../../../assets/icons/language-icon.svg";
import "../dashboard/AnalyticsDashboard.css";

export const DashboardTopbar = () => (
  <header className="dash-topbar">
    <div className="dash-search">
      <input type="text" placeholder="Search..." aria-label="Search" />
      <button type="button" className="dash-search-btn" aria-label="Search">
        <FaSearch />
      </button>
    </div>

    <div className="dash-topbar-right">
      <button type="button" className="dash-lang">
        <img src={languageIcon} alt="language" className="dash-lang-globe" />
        <span>English India</span>
        <FaChevronDown className="dash-lang-caret" />
      </button>
      <button type="button" className="dash-icon-btn" aria-label="Notifications">
        <FaBell />
        <span className="dash-badge">3</span>
      </button>
      <button type="button" className="dash-icon-btn" aria-label="Messages">
        <FaEnvelope />
        <span className="dash-badge">5</span>
      </button>
      <div className="dash-profile">
        <FaUserCircle className="dash-profile-avatar" />
        <div className="dash-profile-meta">
          <span className="dash-profile-name">Hello user name</span>
          <span className="dash-profile-role">Admin</span>
        </div>
      </div>
    </div>
  </header>
);

export default DashboardTopbar;
